const RUSSIAN_KEYS = 'ё йцукенгшщзхъ фывапролджэ ячсмитьбю'
const LATIN_KEYS = "` qwertyuiop[] asdfghjkl;' zxcvbnm,."
const KEYBOARD_LAYOUT = new Map(Array.from(RUSSIAN_KEYS, (key, index) => [key, LATIN_KEYS[index]]))
const QUOTE_SUFFIXES = ['usdt', 'usdc', 'busd', 'usd', 'perp']

/** Correct keyboard positions without discarding unknown text. */
export function normalizeTickerSearch(search: string): string {
  return Array.from(search.trim().toLowerCase(), (key) => KEYBOARD_LAYOUT.get(key) ?? key).join('')
}

function compactSymbol(symbol: string): string {
  const literal = normalizeTickerSearch(symbol)
  // Keep punctuation-only input from becoming an empty (match-all) query.
  return literal.replace(/[\s/_-]/g, '') || literal
}

function matchesQuery(symbol: string, query: string, exact = false): boolean {
  const candidates = query.includes(':') ? [symbol] : [symbol, symbol.replace(/:/g, '')]
  return candidates.some((candidate) => exact ? candidate === query : candidate.includes(query))
}

/** Resolve pair notation against the complete catalog before applying other filters. */
export function createTickerSearchMatcher(search: string, symbols: readonly string[]): (symbol: string) => boolean {
  let query = compactSymbol(search)
  const available = symbols.map(compactSymbol)
  const explicitQuote = /[/_\s-](?:usdt|usdc|busd|usd|perp)$/.test(normalizeTickerSearch(search))
  // TUSD may be the token name, even when T is also listed. Only interpret a
  // trailing quote when the literal name is absent or a separator makes the
  // quote explicit (T_USD), and the base actually exists. Keep namespace colons.
  if (query && !QUOTE_SUFFIXES.includes(query)
    && (explicitQuote || !available.some((symbol) => matchesQuery(symbol, query, true)))) {
    for (const quote of QUOTE_SUFFIXES) {
      if (!query.endsWith(quote)) continue
      const base = query.slice(0, -quote.length).replace(/:$/, '')
      if (base && available.some((symbol) => matchesQuery(symbol, base, true))) query = base
      break
    }
  }
  return (symbol) => !query || matchesQuery(compactSymbol(symbol), query)
}
